import { EntityListProductInputData } from '../entityListTypes';
import { EntityListItemValidator } from './EntityListItemValidator';
import { ImportedItemValidatorContext } from '../../../../../lib/imports/importTypes';

export abstract class BaseEntityListItemValidator<
  T extends EntityListProductInputData,
> implements EntityListItemValidator<T> {
  abstract validate(item: Partial<T>, context?: ImportedItemValidatorContext[]): string[];

  /**
   * Helper class to check if the given property of the item is not empty.
   * @param item pasted item
   * @param key name of the property
   * @protected
   */
  protected hasNonEmptyProperty<K extends keyof T>(
    item: Partial<T>,
    key: K,
  ): item is Partial<T> & { [P in K]: NonNullable<T[P]> } {
    const value = item[key];
    return value !== undefined && (typeof value !== 'string' || value.length > 0);
  }
}
